import { ProfileService } from "@modules/dashbord/dashbord.service.ts";
import { createAsyncThunk } from "@reduxjs/toolkit";

const dashboardService = new ProfileService();

export const getInternStat = createAsyncThunk(
  "dashboard/internStat",
  async () => {
      const dataDashboard = await dashboardService.getInternStat();
      return dataDashboard; 
  }
)

export const getFileInternAgent = createAsyncThunk(
  "dashboard/fileInternAgent",
  async (_, { rejectWithValue }) => {
    try {
      const fileBlob = await dashboardService.getFileInternAgent();
      return fileBlob;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
)

export const getInternCard = createAsyncThunk(
  "dashboard/internCard",
  async () => {
    const internCard = await dashboardService.getInternCard();
    return internCard
  }
)
